import script from "./EventsChang.vue?vue&type=script&setup=true&lang=js"
export * from "./EventsChang.vue?vue&type=script&setup=true&lang=js"

import "./EventsChang.vue?vue&type=style&index=0&id=0145426e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0145426e"]])

export default __exports__